import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "../common/Typography";
import crioLogo from "../../../src/assets/crio-logo.svg";
import { NavLink } from "react-router-dom";

const styles = theme => ({
  navbar: {
    height: "80px",
    background: theme.palette.primary.white,
    display: "flex",
    padding: "0px 32px",
    alignItems: "center",
    borderBottom: "1px solid" + theme.palette.primary.primaryBorder
  }
});
class Navbar extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.navbar}>
        <NavLink to="/">
          <img alt="Crio.Do" src={crioLogo}></img>
          <div style={{ marginLeft: "16px" }}>
            <Typography type="heading4" fontWeight="bold" cursor="pointer">
              {this.props.title}
            </Typography>
          </div>
        </NavLink>
      </div>
    );
  }
}
export default withStyles(styles)(Navbar);
